import { render, staticRenderFns } from "./AberturaProcessoPesquisa.vue?vue&type=template&id=1086a3d2&"
import script from "./AberturaProcessoPesquisa.vue?vue&type=script&lang=js&"
export * from "./AberturaProcessoPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AberturaProcessoPesquisa.vue"
export default component.exports